import {toggle_loader, disable_loader} from '../_loader';

document.addEventListener("DOMContentLoaded", function () {

    //check to see if this page has one or more tyre pressure forms
    let pressure_forms = document.getElementsByClassName('tyre-pressure-form');

    //if we have at least one form...
    if (pressure_forms && pressure_forms.length > 0) {

        //add an event listener to the document to listen for form submissions
        document.addEventListener('submit', function (event) {

            //check if the submitted form is a tyre pressure form
            if (event.target && event.target.classList.contains('tyre-pressure-form')) {

                //prevent the form from submitting
                event.preventDefault();

                //find the parent container
                let container = event.target.closest('.tyre-pressure-block');

                //get our provided registration plate
                let reg = event.target.querySelector('input[name="registration"]').value;

                //if we have a registration plate
                if (reg) {

                    //show the loader
                    toggle_loader();

                    //create a new XMLHttpRequest
                    const xhr = new XMLHttpRequest();

                    //add an event listener to the request
                    xhr.addEventListener("readystatechange", function () {

                        //if the request is done
                        if (this.readyState === this.DONE) {

                            //parse the response
                            let response = JSON.parse(this.responseText);

                            //if we have some response HTML
                            if(response.html && response.html != '' && container) {

                                //replace the entire form with the response HTML
                                container.innerHTML = response.html;
                            }

                            //reinitialize our selects
                            init_pressure_selects();

                            //disable the loader
                            disable_loader();
                        }
                    });

                    //prepare the request
                    xhr.open("GET", '/wp-json/laserred/pressure?registration=' + reg + '&background_colour=' + (container.getAttribute('data-block_colour') ?? 'brand'));
                    xhr.setRequestHeader("Accept", "*/*");
                    xhr.setRequestHeader("Content-Type", "application/json");

                    //send the request
                    xhr.send();
                }
            }
        });

        //initialize our selects
        init_pressure_selects();
    }
});

function init_pressure_selects() {
    var $ = require('jquery');
	const select2 = require('select2');

    let native_selects = document.querySelectorAll('.tyre-pressure-select');

    //create an array that will hold our selects
    let select2_instances = [];

	//Callback event on tyre pressure dropdowns
	$('select.tyre-pressure-select').on("select2:select", function (e) {

        //find the parent block
        let block = (e.target).closest('.tyre-pressure-block');

        //get our size and position values
        let position = block.querySelector('select[name="pressure-position"]').value;
        let size = block.querySelector('select[name="pressure-size"]').value;

        //fetch all the results
        let results = block.querySelectorAll('.tyre-pressure-result');

        //if we have some results...
        if(results && results.length > 0) {

            //loop over them
            for(let i = 0; i < results.length; i++) {

                //if the result has the same position and size as the selected dropdowns
                if(results[i].getAttribute('data-position') && results[i].getAttribute('data-position') === position && results[i].getAttribute('data-size') && results[i].getAttribute('data-size') === size) {

                    //add the visible class
                    results[i].classList.add('tyre-pressure-visible');
                } else { //otherwise...

                    //remove the visible class (if it exists)
                    results[i].classList.remove('tyre-pressure-visible');
                }
            }
        }
	});

    //loop through our native selects
    for(let i = 0; i < native_selects.length; i++) {

        //Tyre pressure dropdowns
        select2_instances[i] = $(native_selects[i]).select2({
            minimumResultsForSearch: -1,
            dropdownParent: $('#select2-focus-container')
        });

        //select the first option that isn't disabled
        $(native_selects[i]).val($(native_selects[i]).find('option:not(:disabled):first').val());

        //trigger our select callback
        $(native_selects[i]).trigger('change');
        $(native_selects[i]).trigger('select2:select');
    }
}